const HOURS_IN_DAY = 24;
const MINUTES_IN_HOUR = 60;
const SECONDS_IN_MIN = 60;

export default {
  HOURS_IN_DAY,
  MINUTES_IN_HOUR,
  SECONDS_IN_MIN,
};
